import React from 'react';
import './FooterMenuList.scss';

/**
 * Renders footer menu lists
 * @param {string} title - the title of the list
 * @param {array} list - array of objects representing each menu item
 * @returns {JSX.Element}
 * @constructor
 */
const FooterMenuList = ({ title, list }) => {
  const renderMenuItems = (items) =>
    items.map((item, i) => (
      <li key={`menu-item-${i}`} className="c-footer-menu-list__list-item body-2">
        <a className="color-white" href={item.url}>
          {item.title}
        </a>
      </li>
    ));

  return (
    <div className="c-footer-menu-list color-white">
      <div className="c-footer-menu-list__title-container eyebrow-2">
        <span className="c-footer-menu-list__title">{title}</span>
      </div>
      <div className="c-footer-menu-list__list-container">
        <ul className="c-footer-menu-list__list">{renderMenuItems(list)}</ul>
      </div>
    </div>
  );
};

export default FooterMenuList;
